// extracted by mini-css-extract-plugin
export default {"truck":"Truck_truck__wrbp2"};